module.exports = __webpack_public_path__ + "img/filter_switch.9fc5672a.svg";